import { Navigate, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home.jsx';
import { Register } from './pages/Register.jsx';
import { Login } from './pages/Login.jsx';
import { ProtectedLayout } from './pages/ProtectedLayout.jsx';
import { DashboardPage } from './pages/DashboardPage.jsx';
import { TenantsPage } from './pages/TenantsPage.jsx';
import { ProductsPage } from './pages/ProductsPage.jsx';
import { SectionsPage } from './pages/SectionsPage.jsx';
import { OrdersPage } from './pages/OrdersPage.jsx';
import { CustomersPage } from './pages/CustomersPage.jsx';
import { CustomerRadarPage } from './pages/CustomerRadarPage.jsx';
import { SubscriptionBillingPage } from './pages/SubscriptionBillingPage.jsx';
import { AdminPage } from './pages/AdminPage.jsx';
import { PublicAgeRestrictionRoute, PublicShopRoute } from './pages/PublicShopRoute.jsx';
import { StoreRecoverPasswordPage } from './pages/StoreRecoverPasswordPage.jsx';
import { StoreResetPasswordPage } from './pages/StoreResetPasswordPage.jsx';
import { StoreCustomerAccountPage } from './pages/StoreCustomerAccountPage.jsx';
import { LegacyLojaRedirect } from './pages/LegacyLojaRedirect.jsx';
import { NotFoundPage } from './pages/NotFoundPage.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/cadastro" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/loja/:slug" element={<LegacyLojaRedirect />} />

      <Route element={<ProtectedLayout />}>
        <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/app/dashboard" element={<DashboardPage />} />
        <Route path="/app/empresa" element={<TenantsPage />} />
        <Route path="/app/mensalidade" element={<SubscriptionBillingPage />} />
        <Route path="/app/produtos" element={<ProductsPage />} />
        <Route path="/app/secoes" element={<SectionsPage />} />
        <Route path="/app/pedidos" element={<OrdersPage />} />
        <Route path="/app/clientes" element={<CustomersPage />} />
        <Route path="/app/radar" element={<CustomerRadarPage />} />
      </Route>

      <Route element={<ProtectedLayout adminOnly />}>
        <Route path="/admin" element={<AdminPage />} />
      </Route>

      {/* Loja pública: confirmação de idade (URL dedicada) antes da rota genérica `/:slug`. */}
      <Route path="/:slug/acesso-idade" element={<PublicAgeRestrictionRoute />} />
      <Route path="/:slug/conta" element={<StoreCustomerAccountPage />} />
      <Route path="/:slug/recuperar-senha" element={<StoreRecoverPasswordPage />} />
      <Route path="/:slug/redefinir-senha" element={<StoreResetPasswordPage />} />
      {/* Loja pública: um segmento só — ex.: /lojateste (depois das rotas acima). */}
      <Route path="/:slug" element={<PublicShopRoute />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
